import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ms-4 text-subtitle-1" }

import MenuList from './MenuList.vue';
// composables
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

// components
const store = useStore();
const router = useRouter();
const { xs } = useDisplay();

const drawer = ref(false);
const toggleDrawerVisibility = () => (drawer.value = !drawer.value);

const userName = computed(() => store.getters.userMail);
const isAuth = computed(() => store.getters.isAuth);

const logout = async function () {
    const message = await store.dispatch('logout');
    store.dispatch('snackbar/showSnackbar', { message, type: 'success' });
    router.replace('/auth');
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isAuth))
      ? (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 0,
          color: "teal-lighten-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar_nav_icon, {
              onClick: toggleDrawerVisibility,
              class: "icon"
            }),
            _createVNode(_component_v_toolbar_title, { class: "hidden-sm-and-down" }, {
              default: _withCtx(() => [
                _createTextVNode("PhoneBook")
              ]),
              _: 1
            }),
            _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('navBar.greeting') + _unref(userName)) + "!", 1),
            _createVNode(_component_v_spacer),
            (_unref(xs))
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: logout,
                  icon: "",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-logout")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  onClick: logout,
                  color: "white",
                  variant: "text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('navBar.logout')), 1)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 1,
          color: "teal-lighten-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, { class: "ms-0 text-center" }, {
              default: _withCtx(() => [
                _createTextVNode("PhoneBook")
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    (_unref(isAuth))
      ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
          key: 2,
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
          width: "300"
        }, {
          default: _withCtx(() => [
            _createVNode(MenuList, { onCloseMenu: toggleDrawerVisibility })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})